import { render } from "./SystemInfo.vue?vue&type=template&id=67e7cdfa"
import script from "./SystemInfo.vue?vue&type=script&lang=js"
export * from "./SystemInfo.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\bp-kmiyajima\\Documents\\Projects\\noritz-portal\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__